<a class="d-inline-block text-nowrap r-full text-reset" [routerLink]="['/']">
  @if (brandLogo) {
    <img [src]="brandLogo" class="align-middle m-2 brand-logo" alt="logo" />
  }
</a>